import { c as _c } from "react/compiler-runtime";
import useBlueshiftLiveContent from '../../hooks/useBlueshiftLiveContent';
import { SlotNames } from '../../constants/blueshift';
import TopBanner from './TopBanner';
interface BannerProps {
  shouldSeeBanner?: boolean;
}
const PredictiveCRMTopBanner = t0 => {
  const $ = _c(4);
  const {
    shouldSeeBanner
  } = t0;
  const {
    liveContent
  } = useBlueshiftLiveContent(SlotNames.TopBanner);
  if (!liveContent) {
    return null;
  }
  const {
    content
  } = liveContent;
  const t1 = content.userId ?? "anonymous";
  let t2;
  if ($[0] !== content || $[1] !== shouldSeeBanner || $[2] !== t1) {
    t2 = <TopBanner shouldSeeBanner={shouldSeeBanner} content={content} userId={t1} />;
    $[0] = content;
    $[1] = shouldSeeBanner;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default PredictiveCRMTopBanner;